<template>
  <div>
    <page-header
      :page="page"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      ref="filterRef"
      class="search-bar"
      search-text=""
      search-container-class="d-flex align-items-center justify-content-end"
      v-model="filters"
      :display-advanced="false"
      :filters="filterManagerConfig"
      >
      <div class="col d-flex justify-content-end align-items-center">
        <dropdown
          icon="fas fa-print"
          :items="reportOptions"
          title="Seleccione"
        />
      </div>
    </filter-manager>
  </div>
</template>

<script>
// components libs
import Dropdown from 'dropdown'
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';

// services
import DocumentServices from '@/modules/report/document';
import ReportServices from '@/modules/report/api';
import TicketsAPI from '@/services/api/detickets.api';

// Constant
import allMonth from '@/utils/constants/listAllMonth';

export default {
  components: {
    Dropdown,
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Solicitud de Asistencia Técnica y Apoyo a la Docencia',
      routes: ['Inicio', 'Informes Generales', 'Solicitud de Asistencia Técnica y Apoyo a la Docencia'],
    },
    filters: {
      dateFrom: null,
      dateTo: null,
      month: null,
      program: null,
      status: null,
      assigned: null,
    },
    isMonthlyReport: false,
    monthOptions: allMonth.LISTMONTH.map(x => ({
      id: x.monthNumber,
      name: x.monthName,
    })),
    programOptions: [],
    statusesOptions: [],
    assignedOptions: [],
  }),
  computed: {
    filterManagerConfig() {
      const newDate = new Date(this.filters.dateFrom);
      newDate.setDate(newDate.getDate() - 1);
      
      return [
        {
          name: 'dateFrom',
          component: 'custom-date-picker',
          label: 'Rango de Fecha',
          placeholder: 'Fecha Desde',
          class: 'col-md-2',
          maxDate: new Date(),
          value: this.filters.dateFrom,
          disabled: !!this.filters.month,
          error: "Favor seleccionar la fecha de comienzo.",
          validations: !this.isMonthlyReport && (!this.filters.month || !!this.filters.dateTo) ? 'required' : '',
        },
        {
          name: 'dateTo',
          component: 'custom-date-picker',
          label: ' ',
          placeholder: 'Fecha Hasta',
          class: 'col-md-2 pt-2',
          maxDate: new Date(),
          minDate: newDate,
          value: this.filters.dateTo,
          disabled: !!this.filters.month,
          error: "Favor seleccionar la fecha de finalización.",
          validations: !this.isMonthlyReport && (!this.filters.month || !!this.filters.dateFrom) ? 'required' : '',
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.monthOptions,
          value: this.filters.month,
          error: "Favor seleccionar el mes.",
          validations: this.isMonthlyReport ? 'required' : '',
        },
        {
          name: 'program',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Programa, área o sección',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.programOptions,
          value: this.filters.program,
        },
        {
          name: 'status',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Estatus',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.statusesOptions,
          value: this.filters.status,
        },
        {
          name: 'assigned',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Asignado',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.assignedOptions,
          value: this.filters.assigned,
        },
      ];
    },
    reportOptions() {
      return [
        {
          label: 'Informe Mensual',
          icon: 'fas fa-file-pdf text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.monthlyReport(),
        },
        {
          label: 'Informe Excel',
          icon: 'fas fa-file-csv text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.processReport(),
        },
      ]
    },
  },
  watch: {
    'filters.month'() {
      this.filters.dateFrom = null;
      this.filters.dateTo = null;
    },
    'filters.dateFrom'(newValue) {
      if (newValue < this.filters.dateTo) return;

      this.filters.dateTo = null;
    }
  },
  async mounted() {
    await this.initFilters();
  },
  methods: {
    async validateFilter() {
      //work-around to wait update filterManagerConfig rules
      await new Promise(resolve => setTimeout(resolve, 100));

      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      return isValid;
    },
    async initFilters() {
      const { data } = await TicketsAPI.getTechnicalAsistanceInitfilter();
      this.programOptions = [...data.modules];
      this.statusesOptions = [...data.statuses];
      this.assignedOptions = [...data.assignees];
    },
    async monthlyReport() {
      this.isMonthlyReport = true;
      const isValid = await this.validateFilter();

      if (!isValid) return;

      const params = {
        monthId: this.filters.month?.id,
        programId: this.filters.program?.id,
        statusId: this.filters.status?.id,
        assignedId: this.filters.assigned?.id,
      };
      
      const { data } = await ReportServices.getReport('monthlytechnicalasistanceandteachingsupport', params);
      await DocumentServices.Download(data);
    },
    async processReport() {
      this.isMonthlyReport = false;
      const isValid = await this.validateFilter();

      if (!isValid) return;

      const params = {
        dateFrom: this.filters.dateFrom,
        dateTo: this.filters.dateTo,
        monthId: this.filters.month?.id,
        programId: this.filters.program?.id,
        statusId: this.filters.status?.id,
        assignedId: this.filters.assigned?.id,
      };

      const { data } = await ReportServices.getReport('technicalasistanceandteachingsupport', params);
      await DocumentServices.Download(data);
    },
  },
};
</script>
